module.exports = __webpack_public_path__ + "static/Gilroy-Black-b8a3b3a91be25a0030d694a34e152217.ttf";